<div class="product-related produto-slider-item" *ngIf="template == 'one'">
    <div class="produtos slider-itens" #slider>   
        <div class="slider-item item-servicos" *ngFor="let item of data"> 
            <produto-item [data]="item"></produto-item>    
        </div>    
    </div>   
    <div class="slide-navigate-item prev" (click)="prev()" *ngIf="(width > 700 && data.length > 4) || (width <= 700)">
        <div class="content">  
            <img src="/images/icons/prev.svg" alt="Prev" width="30px" />
        </div>
    </div>
    <div class="slide-navigate-item next" (click)="next()" *ngIf="(width > 700 && data.length > 4) || (width <= 700)">
        <div class="content"> 
            <img src="/images/icons/next.svg" alt="Next" width="30px" />
        </div>
    </div>
</div>
<div class="product-related produto-slider-item" *ngIf="template == 'two'"> 
    <h3 *ngIf="_titulo != ''">{{_titulo}}</h3>    
    <div class="produtos slider-itens" #slider>   
        <div class="slider-item item-servicos" *ngFor="let item of data"> 
            <produto-item-two [data]="item"></produto-item-two>     
        </div>     
    </div> 
    <div class="slide-navigate-item prev" (click)="prev()" *ngIf="(width > 700 && data.length > 4) || (width <= 700)">
        <div class="content">   
            <img src="/images/icons/prev.svg" alt="Prev" width="30px" />
        </div>
    </div>
    <div class="slide-navigate-item next" (click)="next()" *ngIf="(width > 700 && data.length > 4) || (width <= 700)">
        <div class="content"> 
            <img src="/images/icons/next.svg" alt="Next" width="30px" />
        </div>
    </div>
</div>
